/**
 * Shared types for the monitoring system
 */

// Sentry severity levels - matches @sentry/core SeverityLevel type
export type SentrySeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

// Our internal log levels
export type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'fatal';

// Log categories - matches what's actually used in the codebase
export type LogCategory = 
  | 'auth' 
  | 'database' 
  | 'email' 
  | 'payment' 
  | 'campaign' 
  | 'system' 
  | 'security' 
  | 'performance'
  | 'trialExpiry'
  | 'cron'
  | 'subscription'
  | 'lifecycle';

/**
 * Maps our internal log levels to Sentry severity levels
 */
export const mapToSentryLevel = (level: LogLevel): SentrySeverityLevel => {
  return level === 'warn' ? 'warning' : level;
};

/**
 * Type guard to check if a level is a valid Sentry severity level
 */
export const isSentrySeverityLevel = (level: string): level is SentrySeverityLevel => {
  return ['fatal', 'error', 'warning', 'log', 'info', 'debug'].includes(level);
};
